import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import ServiceApi from '../services/ServiceApi';

const recaptchaSiteKey = process.env.TBX_RECAPTCHA_KEY
    || (window.configOptions && window.configOptions.TBX_RECAPTCHA_KEY);

export const WithRecaptcha = (BaseComponent) => {
    const api = new ServiceApi(this);
    const RecaptchedComponent = props => {
        window.recaptchaRef = React.createRef();
        let [captchaDisabled, setCaptchaDisabled] = useState(false);
        api.obtainRecaptchaConfig()
            .then((res) => {
                setCaptchaDisabled(res.recaptchaDisabled === true);
            })
            .catch(err => console.error(err));
        return <React.Fragment>
            <BaseComponent
                {...props}
            />
            {!captchaDisabled &&
                <ReCAPTCHA
                    ref={window.recaptchaRef}
                    size="invisible"
                    sitekey={recaptchaSiteKey}
                />
            }
        </React.Fragment>;
    };
    return RecaptchedComponent;
};
